import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UpdateUserNotificationPreferenceRequest } from '../../api/update-user-notification-preference/updateUserNotificationPreferenceRequest.types';
import type { UseUpdateUserNotificationPreferenceResult } from './useUpdateUserNotificationPreference.types';

import { updateUserNotificationPreference } from '../../api/update-user-notification-preference/updateUserNotificationPreference';

export function useUpdateUserNotificationPreference(): UseUpdateUserNotificationPreferenceResult {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UpdateUserNotificationPreferenceRequest>({
    mutationFn: (
      data: UpdateUserNotificationPreferenceRequest
    ): Promise<void> => updateUserNotificationPreference(data.id, data),
    onSuccess: async (): Promise<void> => {
      await queryClient.invalidateQueries({
        queryKey: ['user-notification-preferences'],
      });
    },
  });
}
